/* eslint-disable */
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2 } from '@tabler/icons';
import { useNavigate } from 'react-router';
import { auth, RedirectFrontURI } from 'helper/Utility';


// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const handleSwitch = () => {
        const dataParam = {
            token: auth("user")?.token,
            email: auth("user")?.email,
            fullName: auth("user")?.fullName
        }
        window.location.href = `${RedirectFrontURI()}?token=${dataParam?.token}&email=${dataParam?.email}&name=${dataParam.fullName}`
    }

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <IconMenu2 stroke={1.5} size="1.5rem" onClick={handleLeftDrawerToggle} style={{ color: 'white' }} />
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />


            <div className="login-fix-mobile">
                <button className="switchUser" type="button" onClick={handleSwitch}>
                    <i class="fa-solid fa-repeat"></i>
                    <span className="iconTitle d-block"> Switch to user</span>
                </button>
            </div>

            <NotificationSection />
            <ProfileSection />
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
